import React, { ComponentType, ReactElement } from 'react';
import { AUTH_TOKEN_STORAGE_KEY } from 'utils/constants';
import { Route, Redirect } from 'react-router-dom';
import { useAuthStateSelector, useAuthStateManager } from 'hooks/auth';

interface Props {
  component: ComponentType;
  path: string;
}

const ProtectedRoute = ({
  component: Component,
  ...rest
}: Props): ReactElement => {
  const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  const authState = useAuthStateSelector();
  const { authenticate } = useAuthStateManager();

  if (token && !authState.isAuthenticated) {
    authenticate(token);
  }

  return (
    <Route
      {...rest}
      render={(props): ReactElement => {
        if (authState.isAuthenticated) {
          return <Component />;
        }
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: {
                referrer: props.location,
              },
            }}
          />
        );
      }}
    />
  );
};

export default ProtectedRoute;
